import { useEffect, useState } from "react";
import { LoadUtil } from "../../../framework/util/LoadUtil";
import { EnvConstants } from "../../../EnvConstants";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import CadenaAirePage from "./aire/CadenaAirePage";
import CadenaAguaPage from "./agua/CadenaAguaPage";
import CadenaSueloPage from "./suelo/CadenaSueloPage";
import CadenaEmisionPage from "./emision/CadenaEmisionPage";
import CadenaRuidoPage from "./ruido/CadenaRuidoPage";
import CadenaVibracionPage from "./vibracion/CadenaVibracionPage";
import CadenaIluminacionPage from "./iluminacion/CadenaIluminacionPage";
import CadenaRadiacionPage from "./radiacion/CadenaRadiacionPage";
import CadenaEmisionEpa10Page from "./emision-epa-10/CadenaEmisionEpa10Page";
import CadenaRadiacionNoAcreditadoPage from "./radiacion-no-acreditado/CadenaRadiacionNoAcreditadoPage";
import CadenaAireMetereologicoPage from "./aire-metereologico/CadenaAireMetereologicoPage";

export const CadenasPage = () => {
  const { id } = useParams();
  const [data, setData] = useState({
    id_doc: null,
    id_ia: null,
    cadenaActual: 'Sin Cadena',
  });
  const [cadenas] = useState({
    'Ocupacional - Ruido': () => <></>,
    'Ocupacional - Iluminación': () => <></>,
    'Ocupacional - Gases': () => <></>,
    'Ocupacional - Agentes Químicos': () => <></>,
    'Ocupacional - Estrés Térmico': () => <></>,
    'Matriz Agua': (props) => <CadenaAguaPage name={{...props}} />,
    'Matriz Aire': (props) => <CadenaAirePage name={{...props}} />,
    'Matriz Aire Metereológicos': (props) => <CadenaAirePage name={{...props}} />,
    'Matriz Suelo': (props) => <CadenaSueloPage name={{...props}} />,
    'Matriz Ruido': (props) => <CadenaRuidoPage name={{...props}} />,
    'Matriz Emisiones': (props) => <CadenaEmisionPage name={{...props}} />,
    'Matriz Vibraciones': (props) => <CadenaVibracionPage name={{...props}} />,
    'Matriz Iluminaciones': (props) => <CadenaIluminacionPage name={{...props}} />,
    'Matriz Radiaciones': (props) => <CadenaRadiacionPage name={{...props}} />,
    'Matriz Emisiones Gaseosas EPA 10': (props) => <CadenaEmisionEpa10Page name={{...props}} />,
    'Matriz FOMA 066 No Acreditado': (props) => <CadenaRadiacionNoAcreditadoPage name={{...props}} />,
    'Sin Cadena': () => <></>
  })

  const obtenerCadena = () => {
    if (id === '0') {
      const storage = JSON.parse(sessionStorage.getItem("storage_cadena") || '{}');
      setData({
        ...data,
        cadenaActual: storage.cadena
      });
    } else {
      LoadUtil.loadByQueryId({
        url: EnvConstants.GET_URL_READ(),
        queryId: 919,
        reqParams: {
          params: {
            id_cadena: id,
          },
        },
        fnOk: (resp) => {
          setData({
            ...data,
            ...resp.dataObject,
            id_ia: resp.dataObject?.id_ia,
            cadenaActual: resp.dataObject?.tipo_cadena
          });
        },
      });
    }
  }

  useEffect(() => {
    obtenerCadena()
    return () => { }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const CadenaActual = cadenas[data.cadenaActual] || (() => <></>);

  return <CadenaActual {...data} />;
}